import {
  isFinanceRole,
  isGroupLeader,
  isOver18YearsOld,
  isPostCreator,
  isRegularAppUser,
  isSubLeaderRole
} from "./utils";
import { T } from "react-translator-component";

export type MultiMenuTypes = "post" | "chat" | "group_user" | "event_user" | "waiting_approval_member"

export const getMultiMenuOption = (
  currentUser: any,
  targetUser: any,
  menuType: MultiMenuTypes,
  isBlocked: boolean,
  isReported: boolean,
  groupInfo?: any,
  post?: any,
  isOneToOneChat?: boolean,
) => {
  if (menuType === "post" || menuType === "chat") {
    return postMenuOption(
      currentUser,
      currentUser.id === targetUser.id,
      menuType === "post" && post && post.member_group?.id ? true : false,
      isBlocked,
      isReported,
      menuType,
      menuType === "chat" && isOneToOneChat ? true : false,
      menuType === "post" && post && post.is_anonymous === 3 ? true : false,
      groupInfo,
      post
    )
  } else {
    return withinGroupMenuOption(
      currentUser,
      targetUser,
      groupInfo,
      isBlocked,
      menuType,
    )
  }
}

const withinGroupMenuOption = (
  currentUser: any,
  targetUser: any,
  groupInfo: any,
  isBlocked: boolean,
  menuType: "group_user" | "event_user" | "waiting_approval_member"
) => {
  const isCurrentUser = currentUser.id === targetUser.id
  const hasLeadersRole =
    menuType !== "waiting_approval_member" &&
    (isGroupLeader(groupInfo, currentUser) || isSubLeaderRole(groupInfo.role))
  const hasLeadersRoleUser =
    menuType !== "waiting_approval_member" &&
    (isGroupLeader(groupInfo, targetUser) || isSubLeaderRole(targetUser.groupRole))
  const existsPayments = menuType === "group_user" && (groupInfo?.is_paid || groupInfo.fee_amount > 0)
  const isOnlyAdult = existsPayments ? !isOver18YearsOld(targetUser?.dob) : false

  return [
    {
      title: `${T("see_posts")}`,
      path: "/user_detail",
      disabled: !targetUser?.id
    },
    {
      title: `${T("chats")}`,
      path: "/chat",
      disabled: menuType === "waiting_approval_member" || isCurrentUser || isBlocked
    },
    {
      title: `${T("send_private_post")}`,
      path: "/private_post",
      disabled: menuType === "waiting_approval_member" || isCurrentUser || !hasLeadersRole
    },
    {
      title: `${T("switch_role")}`,
      path: "/switching_role",
      disabled: menuType !== "group_user" || isCurrentUser || !hasLeadersRole || isGroupLeader(groupInfo, targetUser) || isOnlyAdult
    },
    {
      title: `${T("kick")}`,
      path: "/delete_member",
      disabled: menuType !== "group_user" || isCurrentUser || !hasLeadersRole || hasLeadersRoleUser || isFinanceRole(targetUser.groupRole)
    },
  ]
}

const postMenuOption = (
  currentUser: any,
  isCurrentUser: boolean,
  forGroup: boolean,
  isBlocked: boolean,
  isReported: boolean,
  menuType: "post" | "chat",
  isOneToOneChat: boolean,
  isAnonymousPost: boolean,
  groupInfo?: any,
  post?: any
) => {
  const isMyPost = menuType === "post" && isPostCreator(post, currentUser)

  const isParticiatedGroup =
    forGroup && (
      isGroupLeader(groupInfo, currentUser) ||
      fetchMemberGroupUsers(groupInfo).some(
        (user: any) => user.id === currentUser.id && (user.status === "approved" || user.status === "unpaid_approved" || user.status === "pending")
      )
    )
  const isDeletedUser = Boolean(post?.creator?.deleted_at)

  return [
    {
      title: forGroup ? `${T("see_group_top_page")}` : `${T("see_posts")}`,
      path: forGroup ? "/group_top" : "/user_detail",
      disabled: (menuType === "post" && isBlocked) || isAnonymousPost
    },
    {
      title: `${T("chats")}`,
      path: "/chat",
      disabled: isCurrentUser || isBlocked || isOneToOneChat || isAnonymousPost || !isRegularAppUser(currentUser) || isDeletedUser
    },
    {
      title: `${T("send_private_post")}`,
      path: "/private_post",
      disabled: isCurrentUser  || isMyPost || isBlocked || isAnonymousPost || !isRegularAppUser(currentUser) || isDeletedUser
    },
    {
      title: isBlocked ? `${T("execute_unblock")}` : `${T("execute_block")}`,
      path: "/block",
      disabled: isCurrentUser || (menuType === "chat" && !isOneToOneChat && !isBlocked) || !isRegularAppUser(currentUser) || (menuType === "post" && isParticiatedGroup) || (!forGroup && isDeletedUser)
    },
    {
      title: `${T("execute_report")}`,
      path: "/report",
      disabled: menuType !== "post" || isCurrentUser || isBlocked || isReported || !isRegularAppUser(currentUser)
    },
  ]
}

// メニュー用にユーザーのデータを成型
export const adjustUserInfo = (userInfo: any, groupInfo?: any) => {
  if (!userInfo) return {}
  const user = userInfo?.user ?? userInfo
  let groupRole = ""
  let memberGroupUserId
  if (groupInfo) {
    const memberGroupUsers = fetchMemberGroupUsers(groupInfo)
    const targetMember = memberGroupUsers?.find((groupUser: any) => groupUser.id === user.id)
    groupRole = targetMember?.group_role ?? ""
    memberGroupUserId = targetMember?.member_group_user_id
  }
  return {
    id: user?.user_id ?? user.id,
    name: user.name,
    nickname: user.nickname,
    image: user.image,
    description: user.description,
    dob: user.dob,
    groupRole: groupRole,
    memberGroupUserId: memberGroupUserId,
    class_name: user.class_name,
  }
}

const fetchMemberGroupUsers = (groupInfo: any) => {
  if (!groupInfo) return []
  return groupInfo.memberGroupUsers ?? groupInfo.member_group_users
}